/** 부·류 hierarchical 펼침 테이블 (씨엘HS 부·류 목록 미러). */
import React, { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import { SECTIONS, CHAPTERS_97 } from "./chaptersData";
import "./theme.css";

const NAME_BY_CH = Object.fromEntries(CHAPTERS_97.map((c) => [c.ch, c.name]));

export default function SectionChapterHierarchy({
  onChapterClick,
  initialExpanded = false,
}) {
  const [expanded, setExpanded] = useState(
    Object.fromEntries(SECTIONS.map((s) => [s.sec, initialExpanded])),
  );

  return (
    <div className="audit-root" style={{ padding: 16 }}>
      <h2
        style={{
          fontSize: 13,
          color: "var(--audit-text-muted)",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          margin: "0 0 10px 0",
        }}
      >
        부 · 류
      </h2>
      <div
        style={{
          border: "1px solid var(--audit-border)",
          borderRadius: 6,
          background: "var(--audit-bg-elevated)",
        }}
      >
        {SECTIONS.map(({ sec, name, chapters }) => {
          const open = expanded[sec];
          return (
            <div
              key={sec}
              style={{ borderBottom: "1px solid var(--audit-border)" }}
            >
              <button
                onClick={() => setExpanded((e) => ({ ...e, [sec]: !e[sec] }))}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: "transparent",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  fontSize: 13,
                  color: "var(--audit-text)",
                }}
              >
                {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                <span style={{ fontWeight: 600 }}>{sec}</span>
                <span style={{ color: "var(--audit-text-muted)" }}>{name}</span>
                <span
                  style={{
                    marginLeft: "auto",
                    fontSize: 12,
                    color: "var(--audit-text-faint)",
                    fontFamily: "JetBrains Mono, monospace",
                  }}
                >
                  {chapters[0]}~{chapters[chapters.length - 1]}
                </span>
              </button>
              {open && (
                <div
                  style={{
                    padding: "0 14px 12px 36px",
                    display: "grid",
                    gap: 4,
                  }}
                >
                  {chapters.map((ch) => (
                    <button
                      key={ch}
                      onClick={() => onChapterClick?.(ch)}
                      style={{
                        padding: "4px 8px",
                        textAlign: "left",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontSize: 12,
                        color: "var(--audit-text)",
                        borderRadius: 4,
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background =
                          "var(--audit-bg-hover)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <span
                        style={{
                          fontFamily: "JetBrains Mono, monospace",
                          color: "var(--audit-text-muted)",
                          marginRight: 8,
                        }}
                      >
                        {ch}
                      </span>
                      {NAME_BY_CH[ch] || ""}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
